import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  durationButton: {
    fontSize: 13,
    fontWeight: 'normal',
    textTransform: 'none',
    letterSpacing: 0,
    minWidth: 86,
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  datePicker: {
    width: 120,
    color: '#808080',
    paddingLeft: 0,
    paddingRight: 0,
  },
  tilde: {
    paddingLeft: 9,
    paddingRight: 9,
  },
}));

export default useStyles;
